module.exports = __webpack_public_path__ + "static/media/game(20).159604a8.PNG";